import actionTypes from './actionTypes';
import logSource from '../../sources/logs';
import format from 'date-fns/format';
import moment from 'moment';
import { addNotification } from './notification';
import { stringify } from 'query-string';

export const updateDateFilter = date => ({
    type: actionTypes.LOGS_SET_DATE_FILTER,
    payload: {
        date,
    },
});

export const updateUserFilter = users => ({
    type: actionTypes.LOGS_SET_USER_FILTER,
    payload: {
        users,
    },
});

export const removeUserFilter = user => (dispatch, getState) => {
    const { logs } = getState();
    const users = logs.filterUsers.filter(u => u !== user);

    dispatch({
        type: actionTypes.LOGS_SET_USER_FILTER,
        payload: {
            users,
        },
    });
};

export const updateLogTypeFilter = logTypes => ({
    type: actionTypes.LOGS_SET_LOG_TYPE_FILTER,
    payload: {
        logTypes,
    },
});

export const removeLogTypeFilter = logType => (dispatch, getState) => {
    const { logs } = getState();
    const logTypes = logs.filterTypes.filter(t => t !== logType);

    dispatch({
        type: actionTypes.LOGS_SET_LOG_TYPE_FILTER,
        payload: {
            logTypes,
        },
    });
};

export const resetFilters = () => ({
    type: actionTypes.LOGS_RESET_FILTERS,
});

export const updatePageNumber = pageNumber => ({
    type: actionTypes.LOGS_SET_PAGE,
    payload: {
        pageNumber,
    },
});

export const fetchLogs = authenticationToken => async (dispatch, getState) => {

    dispatch({
        type: actionTypes.LOGS_SET_LOADER,
        payload: {
            isLoading: true,
        },
    });

    const { logs } = getState();
    const { filterTypes, filterUsers, filterDate, page, pageSize } = logs;

    const from = moment(filterDate).startOf('day');
    const to = moment(filterDate).endOf('day');

    const parameters = {
        from: format(from),
        to: format(to),
        type: filterTypes.map(type => type.value),
        user: filterUsers.map(user => user.value),
        page,
        pageSize,
    };

    try {
        const payload = await logSource.getAuditLogs(
            stringify(parameters),
            authenticationToken,
        );

        dispatch({
            type: actionTypes.LOGS_SET,
            payload,
        });

    } catch (error) {

        const response = JSON.parse(error.message);
        dispatch(addNotification({
            type: 'error',
            message: response.message,
            isPersistent: true,
        }));
    }
};
